"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadioButtonGroupDefaultProps = exports.RadioButtonGroup = exports.RadioButtonDefaultProps = exports.RadioButton = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uuid = _interopRequireDefault(require("uuid"));

var _Icons = require("../../foundation/Icons");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var RadioButton = function RadioButton(props) {
  var classNames = props.classNames,
      disabled = props.disabled,
      checked = props.checked,
      label = props.label,
      onClick = props.onClick,
      id = props.id,
      NewProps = _objectWithoutProperties(props, ["classNames", "disabled", "checked", "label", "onClick", "id"]);

  var _useState = (0, _react.useState)(id !== 'undefined' ? id : (0, _uuid.default)()),
      _useState2 = _slicedToArray(_useState, 1),
      InputID = _useState2[0]; // uuid was changing every re-render so storing once.


  var refRadioButton = (0, _react.useRef)(null);
  var radioButtonContainerClassNames = (0, _classnames.default)({
    'radiobutton-component': true,
    'radiobutton-component--disabled': disabled,
    'radiobutton-component--selected': checked
  }, classNames);
  var radioButtonLabelClassNames = (0, _classnames.default)({
    'radiobutton-component__label': true,
    'radiobutton-component__label-position-right': true
  }); // Hiding unused radio icons stops issues with wrapper components such as poppermenu.

  var radioButtonIconFilledClassNames = (0, _classnames.default)({
    'radiobutton-component__icon--hidden': !checked
  });
  var radioButtonIconCircleClassNames = (0, _classnames.default)({
    'radiobutton-component__icon--hidden': checked
  }); // ADA compliant - allow an enter key to select a radio button.

  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  var addRadioParams = disabled ? {} : {
    onClick: onClick,
    tabIndex: 0,
    onKeyDown: _handleKeyPress,
    role: 'button'
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: radioButtonContainerClassNames
  }, NewProps, addRadioParams, {
    id: InputID,
    ref: refRadioButton
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: radioButtonLabelClassNames,
    htmlFor: InputID
  }, label && /*#__PURE__*/_react.default.createElement("span", {
    className: "radiobutton-component__label__text"
  }, label), /*#__PURE__*/_react.default.createElement(_Icons.IcoFilledCircle, {
    className: radioButtonIconFilledClassNames
  }), /*#__PURE__*/_react.default.createElement(_Icons.IcoCircle, {
    className: radioButtonIconCircleClassNames
  })));
};

exports.RadioButton = RadioButton;
RadioButton.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  checked: _propTypes.default.bool.isRequired,
  label: _propTypes.default.string,
  value: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func,
  id: _propTypes.default.string
};
var RadioButtonDefaultProps = {
  classNames: {},
  disabled: false,
  checked: false
};
exports.RadioButtonDefaultProps = RadioButtonDefaultProps;
RadioButton.defaultProps = RadioButtonDefaultProps;
/*
** Radio Button Group
 */

var RadioButtonGroup = function RadioButtonGroup(props) {
  var _classNamesFn;

  var classNames = props.classNames,
      disabled = props.disabled,
      children = props.children,
      onClick = props.onClick,
      size = props.size,
      NewProps = _objectWithoutProperties(props, ["classNames", "disabled", "children", "onClick", "size"]);

  var _useState3 = (0, _react.useState)(function () {
    // First time through? find if anything is already selected.
    var ret;

    _react.default.Children.forEach(children, function (child, index) {
      if (child.props.checked) {
        ret = index;
      }
    });

    return ret;
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      currentlySelected = _useState4[0],
      setCurrentlySelected = _useState4[1]; // Wrap the children in a supporter div to handle the look/feel


  var renderWrappedChildren = _react.default.Children.map(children, function (child, index) {
    var childDisabled = child.props.disabled || disabled; // function to handle the element being clicked.

    var wrappedOnClick = function wrappedOnClick(event) {
      event.stopPropagation();
      event.preventDefault();

      if (!childDisabled) {
        var newCurrentlySelected = index;
        var newCurrentValue = child.props.value;
        setCurrentlySelected(newCurrentlySelected);

        if (child.props.onClick) {
          child.props.onClick(event, index, typeof newCurrentlySelected !== 'undefined', newCurrentValue);
        } // Click RadioButtonGroup onClick.


        if (onClick) {
          onClick(event, index, typeof newCurrentlySelected !== 'undefined', newCurrentValue);
        }
      }
    };

    var newChild = _react.default.cloneElement(child, {
      key: index,
      disabled: childDisabled,
      checked: index === currentlySelected,
      onClick: wrappedOnClick
    });

    return newChild;
  });

  var radioButtonGroupClassNames = (0, _classnames.default)((_classNamesFn = {
    'radiobuttongroup-component': true
  }, _defineProperty(_classNamesFn, "radiobuttongroup-component--size-".concat(size), true), _defineProperty(_classNamesFn, 'radiobuttongroup-component--disabled', disabled), _classNamesFn), classNames);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: radioButtonGroupClassNames
  }, NewProps), renderWrappedChildren);
};

exports.RadioButtonGroup = RadioButtonGroup;
RadioButtonGroup.propTypes = {
  disabled: _propTypes.default.bool.isRequired,
  classNames: _propTypes.default.any.isRequired,
  size: _propTypes.default.oneOf(['small', 'large']).isRequired,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func
};
var RadioButtonGroupDefaultProps = {
  disabled: false,
  classNames: {},
  size: 'large'
};
exports.RadioButtonGroupDefaultProps = RadioButtonGroupDefaultProps;
RadioButtonGroup.defaultProps = RadioButtonGroupDefaultProps;
var _default = RadioButton;
exports.default = _default;